import React from "react";

import { observer } from "mobx-react";
import Link from "next/link";
import styled from "styled-components";

import { useStores } from "../../contexts/StoreContext";

const StyledCategoriesList = styled.ul`
  padding-left: 0;
`;
const StyledCategoryButton = styled.li`
  background-color: ${({ theme }) => theme.primaryBackgroundColor};
  list-style: none;

  a {
    display: block;
    padding: 1rem 2rem;
    margin-bottom: 0.75rem;
    color: ${({ theme }) => theme.textColor};
    background-color: ${({ theme }) => theme.secondaryBackgroundColor};
    text-decoration: none;
  }
`;

function BlogSidebar() {
  const { blogStore } = useStores();

  const { categories } = blogStore;

  return (
    <>
      <h2 className="categories">Categories</h2>
      <StyledCategoriesList>
        {categories.map(({ categoryName, slug }) => {
          const href = `/blog?category=${slug}`;
          return (
            <StyledCategoryButton key={slug}>
              <Link href={href} className="category-label">
                {categoryName}
              </Link>
            </StyledCategoryButton>
          );
        })}
        <StyledCategoryButton>
          <Link href="/blog">All posts</Link>
        </StyledCategoryButton>
      </StyledCategoriesList>
    </>
  );
}

export default observer(BlogSidebar);
